module.exports = __webpack_public_path__ + "img/image_gallery3.98dfaef7.jpg";